<template>
  <aside class="fixed right-[2vw] bottom-[2vw] max-lg:hidden z-10">
    <!-- v-if="$route.path && $route.path.includes('/mall')" -->
    <button class="chatbot block relative mb-2" @click="toggleChat">
      <span class="chatbot-banner" :class="{ 'animate-initial': showInitialAnim }"> 문의사항이 있으신가요? 챗봇으로 상담하세요. </span>
      <img src="/assets/image/ai-chat-icon.png" alt="챗봇 상담" class="relative z-10" />
    </button>

    <!-- <button type="button" @click="scrollToTop">
      <svg
        width="45"
        height="45"
        viewBox="0 0 45 45"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="44"
          height="44"
          rx="9.5"
          fill="white"
          stroke="#0C3388"
        />
        <path
          d="M24.0927 17.7916V32.5384H21.6005V17.7916L14.9163 24.2903L13.1543 22.5772L22.8466 13.1538L32.5389 22.5772L30.7769 24.2903L24.0927 17.7916Z"
          fill="#0C3388"
        />
      </svg>
    </button> -->
    <a href="https://pf.kakao.com/_YqHmu/chat" target="_blank">
      <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="45" height="45" rx="10" fill="#FFF100" />
        <path
          d="M22.845 11.5176C29.2186 11.5176 34.3845 15.8192 34.3845 21.127C34.3845 26.4335 29.2186 30.7351 22.8461 30.7351C22.2115 30.7355 21.5776 30.6923 20.9483 30.606L16.1043 33.9907C15.5538 34.3018 15.3593 34.2678 15.5856 33.5058L16.5659 29.1878C13.401 27.4737 11.3076 24.5034 11.3076 21.127C11.3076 15.8204 16.4725 11.5176 22.8461 11.5176H22.845Z"
          fill="#1B1D21"
        />
      </svg>
    </a>
  </aside>

  <!-- AI 검색 iframe 레이어
       한국어 주석: 모바일에서도 MainInquirySection 등 외부 진입점에서 호출될 수 있도록
       max-lg:hidden 인 <aside> 외부에 배치한다. -->
  <div
    v-if="isChatOpen"
    class="fixed z-30 bg-white shadow-2xl overflow-hidden
           max-lg:inset-0 max-lg:rounded-none max-lg:border-0
           lg:right-[calc(2vw+3.5rem)] lg:bottom-[2vw] lg:rounded-xl lg:border lg:border-neutral-200"
    :style="panelStyle"
  >
    <!-- 한국어 주석: PC에서 창 크기 조절 손잡이 (창이 오른쪽 아래에 붙어 있어 왼쪽·위쪽으로 늘린다) -->
    <template v-if="isDesktop">
      <div class="resize-handle resize-left" title="끌어서 창 너비 조절" @pointerdown.prevent="startResize($event, 'x')"></div>
      <div class="resize-handle resize-top" title="끌어서 창 높이 조절" @pointerdown.prevent="startResize($event, 'y')"></div>
    </template>

    <!-- 상단 막대: 크기 조절 손잡이 / 크게 보기 / 닫기 -->
    <div class="flex items-center justify-end gap-3 px-3 py-2 border-b border-neutral-200 bg-neutral-50">
      <!-- 한국어 주석: 왼쪽 위 모서리 손잡이 — 보이는 아이콘과 글로 끌 수 있음을 알린다 -->
      <div
        v-if="isDesktop"
        class="resize-grip mr-auto"
        title="끌어서 창 크기 조절 (두 번 누르면 기본 크기)"
        @pointerdown.prevent="startResize($event, 'xy')"
        @dblclick="resetSize"
      >
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M1.5 5.5v-4h4M1.5 1.5l11 11M12.5 8.5v4h-4" />
        </svg>
        <span>끌어서 크기 조절</span>
      </div>
      <button v-if="isDesktop" type="button" class="text-xs text-neutral-500 hover:text-neutral-800" @click="toggleLarge">
        {{ large ? "원래 크기" : "크게 보기" }}
      </button>
      <button type="button" class="text-neutral-500 hover:text-neutral-800" @click="toggleChat" aria-label="닫기">✕</button>
    </div>
    <!-- 한국어 주석: 크기를 끄는 동안에는 iframe 이 마우스를 가져가지 않게 한다 -->
    <iframe
      :key="iframeKey"
      title="AI 검색"
      :src="iframeSrc"
      :style="{ width: '100%', height: 'calc(100% - 41px)', border: 0, pointerEvents: resizing ? 'none' : 'auto' }"
    ></iframe>
  </div>
</template>

<script>
import { openLoginDialog, useLoginDialog } from "@/composables/useLoginDialog";
import { markReopenChatbot, takeReopenChatbot } from "@/composables/useAuthReturn";

export default {
  // 한국어 주석: 버튼 클릭 시 AI 검색 페이지를 아이프레임으로 띄우는 레이어를 토글합니다.
  data() {
    return {
      isChatOpen: false, // 한국어 주석: 아이프레임 레이어 열림 상태
      showInitialAnim: false, // 한국어 주석: 최초 1회 배너 애니메이션 실행 여부
      initialQuery: "", // 한국어 주석: 외부 진입점에서 전달된 초기 질문
      iframeKey: 0, // 한국어 주석: 동일 진입점 재호출 시 iframe 강제 리로드용 키
      // 한국어 주석: PC 채팅창 크기. 고른 크기(pref)는 localStorage 에 기억하고, 보이는 크기는 화면에 맞춰 줄인다
      viewW: window.innerWidth,
      viewH: window.innerHeight,
      prefW: 450,
      prefH: 760,
      large: false, // [크게 보기] 중 (끄면 고른 크기로 돌아간다)
      resizing: null, // { mode, pointerId, startX, startY, startW, startH }
    };
  },
  computed: {
    isDesktop() {
      return this.viewW >= 1024;
    },
    // 한국어 주석: 창 오른쪽·아래 여백(2vw + 버튼 자리)을 뺀 만큼까지 키울 수 있다
    maxSize() {
      const gap = this.viewW * 0.02;
      return { w: Math.round(this.viewW - gap - 56 - 24), h: Math.round(this.viewH - gap - 24) };
    },
    displaySize() {
      if (this.large) return { w: Math.min(760, this.maxSize.w), h: this.maxSize.h };
      return this.clampSize(this.prefW, this.prefH);
    },
    // 한국어 주석: PC에서만 크기를 지정한다 (휴대폰은 전체 화면)
    panelStyle() {
      if (!this.isDesktop) return {};
      return { width: this.displaySize.w + "px", height: this.displaySize.h + "px" };
    },
    // 한국어 주석: 초기 질문이 있을 경우 ?q= 파라미터로 aiSearchPage에 전달
    iframeSrc() {
      if (this.initialQuery) {
        return "/mall/ai-search?q=" + encodeURIComponent(this.initialQuery);
      }
      return "/mall/ai-search";
    },
  },
  mounted() {
    this.restoreSize();
    window.addEventListener("resize", this.handleWindowResize);

    // 한국어 주석: 세션 내 최초 1회만 배너 애니메이션을 실행합니다.
    const alreadyShown = sessionStorage.getItem("chatbotBannerShown") === "1";
    if (!alreadyShown) {
      this.showInitialAnim = true;
      sessionStorage.setItem("chatbotBannerShown", "1");
    }

    // 한국어 주석: 다른 진입점(MainInquirySection 등)에서 챗봇 열기 요청 수신
    window.addEventListener("open-ai-chat", this.handleOpenAiChat);
    // 한국어 주석: 챗봇(iframe)이 보낸 로그인 창 열기 요청 수신
    window.addEventListener("message", this.handleChatbotMessage);

    // 한국어 주석: 챗봇에서 로그인·가입을 시작해 돌아왔으면 챗봇을 다시 연다
    if (takeReopenChatbot()) {
      this.isChatOpen = true;
    } else {
      // 한국어 주석: 공유 링크(?chat=질문)로 들어오면 그 질문으로 챗봇을 연다. 새로고침 때 다시 열리지 않게 주소에서 지운다
      const url = new URL(window.location.href);
      const sharedQuestion = (url.searchParams.get("chat") || "").trim().slice(0, 100);
      if (sharedQuestion) {
        this.initialQuery = sharedQuestion;
        this.isChatOpen = true;
        url.searchParams.delete("chat");
        window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
      }
    }
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleWindowResize);
    this.stopResize();
    window.removeEventListener("open-ai-chat", this.handleOpenAiChat);
    window.removeEventListener("message", this.handleChatbotMessage);
  },
  methods: {
    // ---------- 한국어 주석: PC 채팅창 크기 조절 ----------
    clampSize(w, h) {
      const max = this.maxSize;
      return { w: Math.round(Math.min(Math.max(w, 360), max.w)), h: Math.round(Math.min(Math.max(h, 420), max.h)) };
    },
    savePref() {
      try {
        localStorage.setItem("chatbotSize", JSON.stringify({ w: this.prefW, h: this.prefH }));
      } catch (e) {
        // 저장할 수 없어도 이번 화면에서는 바꾼 크기로 쓴다
      }
    },
    restoreSize() {
      let saved = null;
      try {
        saved = JSON.parse(localStorage.getItem("chatbotSize") || "null");
      } catch (e) {
        saved = null;
      }
      const valid = (v) => typeof v === "number" && Number.isFinite(v) && v > 0;
      if (saved && valid(saved.w) && valid(saved.h)) {
        this.prefW = saved.w;
        this.prefH = saved.h;
      }
    },
    resetSize() {
      this.large = false;
      this.prefW = 450;
      this.prefH = 760;
      this.savePref();
    },
    toggleLarge() {
      this.large = !this.large;
    },
    handleWindowResize() {
      this.viewW = window.innerWidth;
      this.viewH = window.innerHeight;
    },
    startResize(event, mode) {
      if (event.button !== 0 || this.resizing) return;
      // 크게 보는 중에 끌면 지금 크기에서 이어서 조절한다
      if (this.large) {
        this.prefW = this.displaySize.w;
        this.prefH = this.displaySize.h;
        this.large = false;
      }
      const start = this.displaySize;
      this.resizing = { mode, pointerId: event.pointerId, startX: event.clientX, startY: event.clientY, startW: start.w, startH: start.h };
      try {
        event.currentTarget.setPointerCapture(event.pointerId);
      } catch (e) {
        // 캡처가 안 돼도 window 이벤트로 끝을 잡는다
      }
      window.addEventListener("pointermove", this.onResize);
      window.addEventListener("pointerup", this.stopResize);
      window.addEventListener("pointercancel", this.stopResize);
      window.addEventListener("blur", this.stopResize);
    },
    onResize(event) {
      const r = this.resizing;
      if (!r || event.pointerId !== r.pointerId) return;
      // 왼쪽·위로 끌면(좌표가 줄면) 커진다
      const w = r.mode.includes("x") ? r.startW + (r.startX - event.clientX) : r.startW;
      const h = r.mode.includes("y") ? r.startH + (r.startY - event.clientY) : r.startH;
      const size = this.clampSize(w, h);
      this.prefW = size.w;
      this.prefH = size.h;
    },
    stopResize(event) {
      if (event && event.pointerId !== undefined && this.resizing && event.pointerId !== this.resizing.pointerId) return;
      if (this.resizing) this.savePref(); // 끝난 크기를 기억
      this.resizing = null;
      window.removeEventListener("pointermove", this.onResize);
      window.removeEventListener("pointerup", this.stopResize);
      window.removeEventListener("pointercancel", this.stopResize);
      window.removeEventListener("blur", this.stopResize);
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    toggleChat() {
      // 한국어 주석: 직접 클릭으로 토글할 때는 초기 질문을 비움
      if (!this.isChatOpen) {
        this.initialQuery = "";
      }
      this.isChatOpen = !this.isChatOpen;
    },
    handleChatbotMessage(event) {
      // 한국어 주석: 같은 사이트의 챗봇 iframe 이 보낸 메시지만 처리
      if (event.origin !== window.location.origin) return;
      if (event.data && event.data.type === "chatbot:open-login") {
        markReopenChatbot();
        this.isChatOpen = false; // 로그인 창이 챗봇 창에 가리지 않도록 닫는다
        // 한국어 주석: 상단 메뉴(로그인 창)가 없는 화면이면 로그인 페이지로 보낸다 (복귀 경로는 라우터가 기억)
        if (useLoginDialog().loginDialogRef.value) {
          openLoginDialog();
        } else {
          this.$router.push("/login");
        }
      }
    },
    handleOpenAiChat(event) {
      // 한국어 주석: 외부에서 전달된 질문으로 챗봇을 열고 자동 전송 트리거
      const query = event && event.detail && event.detail.query ? String(event.detail.query) : "";
      this.initialQuery = query;
      this.iframeKey += 1; // 동일 질문 재요청 시에도 iframe이 다시 로드되도록 key 변경
      this.isChatOpen = true;
    },
  },
};
</script>

<style scoped>
/* 한국어 주석: 채팅창 크기 조절 손잡이 */
.resize-handle {
  position: absolute;
  z-index: 2;
  touch-action: none;
}
.resize-left {
  left: 0;
  top: 12px;
  bottom: 0;
  width: 6px;
  cursor: ew-resize;
}
.resize-top {
  top: 0;
  left: 12px;
  right: 0;
  height: 6px;
  cursor: ns-resize;
}
/* 가장자리에 마우스를 올리면 끌 수 있는 선이 보인다 */
.resize-left::after,
.resize-top::after {
  content: "";
  position: absolute;
  background: #0c3388;
  opacity: 0;
  transition: opacity 0.15s;
}
.resize-left::after {
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
}
.resize-top::after {
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
}
.resize-left:hover::after,
.resize-top:hover::after {
  opacity: 0.6;
}
/* 왼쪽 위 손잡이 */
.resize-grip {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  margin-left: -0.25rem;
  padding: 0.25rem 0.5rem;
  border-radius: 0.375rem;
  font-size: 0.75rem;
  color: #64748b;
  cursor: nwse-resize;
  user-select: none;
  touch-action: none;
}
.resize-grip:hover {
  color: #0c3388;
  background: rgba(12, 51, 136, 0.08);
}

button,
a {
  filter: drop-shadow(0px 3px 3px #00000020);
}

.chatbot-banner {
  position: absolute;
  right: 0;
  display: flex;
  width: 0;
  height: 45px;
  align-items: center;
  background: #0c3388;
  color: #fff;
  border-radius: 12px;
  opacity: 0;
  font-size: 0.875rem;
  padding-left: 0.75rem;
  white-space: pre;
  transition: width 0.5s, opacity 0.5s;
  overflow: hidden;
}

.chatbot:hover .chatbot-banner {
  width: 322px;
  opacity: 1;
}
</style>
